import axios from 'axios'
import { v4 as uuidv4 } from 'uuid'
import { loginAction } from './authenticationReducer'
import * as actions from '../../actionTypes'

const GET_CURRENT_REGISTER = 'GET_CURRENT_REGISTER'
const GET_CURRENT_REGISTER_SUCCESS = 'GET_CURRENT_REGISTER_SUCCESS'
const GET_CURRENT_REGISTER_FAILURE = 'GET_CURRENT_REGISTER_FAILURE'

const baseURL = process.env.REACT_APP_SERVICE_URL

const timeout = process.env.REACT_APP_AXIOS_TIME_OUT

const initialState = {
  isRegistered: false,
  uniqueID: '',
  password: '',
}

const instance = axios.create({
  timeout: parseInt(timeout),
})

// Reducer
export default (state = initialState, action) => {
  switch (action.type) {
    case GET_CURRENT_REGISTER_SUCCESS:
      return {
        ...initialState,
        isRegistered: action.payload.isRegistered,
        uniqueID: action.payload.uniqueID,
        password: action.payload.password,
      }
    case GET_CURRENT_REGISTER:
    case GET_CURRENT_REGISTER_FAILURE: {
      return initialState
    }
    case actions.CLEAR_ALL: {
      return initialState
    }
    default:
      return state
  }
}

export const registerAction = (langKey = 'en') => {
  const login = (' ' + uuidv4()).slice(1)
  const email = `${login}@test.com`
  const password = (' ' + uuidv4()).slice(1)
  return (dispatch) => {
    dispatch({ type: GET_CURRENT_REGISTER })
    return instance.post(`${baseURL}services/usersandroles/api/register`, { login, email, password, langKey }).then(
      // return axios.get('https://swapi.py4e.com/api/people/').then(
      (response) => {
        return response.status === 201
          ? dispatch({
              type: GET_CURRENT_REGISTER_SUCCESS,
              payload: {
                isRegistered: true,
                uniqueID: login,
                password: password,
              },
            })
          : dispatch({ type: GET_CURRENT_REGISTER_FAILURE })
      },
      (err) => {
        dispatch({ type: GET_CURRENT_REGISTER_FAILURE })
        throw new Error('Error in registering')
      }
    )
  }
}

export function registerAndLogin() {
  return (dispatch, getState) => {
    return dispatch(registerAction())
      .then(() => {
        const userName = getState().register.uniqueID
        const password = getState().register.password
        return dispatch(loginAction(userName, password)).catch((e) => {
          throw e
        })
      })
      .catch((e) => {
        throw e
      })
  }
}
